<template lang="pug">
#tabela-infos-profissionais-pf
    BaseTableHeader(
        :icone-titulo-tabela='iconeTituloTabela',
        :titulo-tabela='tituloTabela'
    )

    el-collapse(v-model='activeCollapseItem')
        div(v-for='(item, index) in tiposInfosProfissionais')
            el-collapse-item(:title='item.titulo', :name='index.toString()')
                template(slot='title')
                    | {{ item.titulo }}
                    i.mdi.mdi-minus-circle.ml-2(v-if='!item.temResultados', style='font-size: 20px; color: #686868')
                div(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.modulos.informacoesProfissionais") && dados["pessoa-renda-estimada-v2"]'
                )
                    BaseInfoBlock(
                        :titulos-info-block='[$t("mensagens.preAnaliseCredito.informacoesProfissionais.valorRendaEstimada"), $t("mensagens.preAnaliseCredito.informacoesProfissionais.valorNovaRendaEstimada")]',
                        :valores-info-block='[dados["pessoa-renda-estimada-v2"].faixaRenda, dados["pessoa-renda-estimada-v2"].faixaRendaEstimada]',
                        :valor-moeda='true'
                    )
                    el-divider
                    BaseInfoBlock(
                        :titulos-info-block='[$t("mensagens.preAnaliseCredito.informacoesProfissionais.profissaoExercida"), $t("mensagens.preAnaliseCredito.informacoesProfissionais.servidorPublico")]',
                        :valores-info-block='[dados.profissaoNeoway, dados.servidorPublico || "NÃO"]'
                    )
                el-alert(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.modulos.informacoesProfissionais") && !dados["pessoa-renda-estimada-v2"]',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )

                div(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.informacoesProfissionais.cvmDadosCadastrais") && dados.cvmParticipantes'
                )
                    BaseInfoBlock(
                        :titulos-info-block='[$t("mensagens.preAnaliseCredito.informacoesProfissionais.setorMercadoQueAtuaPessoaEmQuestao")]',
                        :valores-info-block='[dados.cvmParticipantes.dadosCadastrais.atividadeSetor]'
                    )
                el-alert(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.informacoesProfissionais.cvmDadosCadastrais") && !dados.cvmParticipantes',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )

                div(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.informacoesProfissionais.historicoFuncional") && dados.historicoFuncional'
                )
                    div(v-for='historico in dados.historicoFuncional')
                        BaseInfoBlock(
                            :titulos-info-block='[$t("mensagens.preAnaliseCredito.informacoesProfissionais.razaoSocial"), "CNPJ", $t("mensagens.preAnaliseCredito.informacoesProfissionais.dataAdmissao"), $t("mensagens.preAnaliseCredito.informacoesProfissionais.dataDesligamento")]',
                            :valores-info-block='[historico.razaoSocial, numeralStringFormatTocpfCnpj(historico.cnpj), mxFormatarData(historico.dataAdmissao), mxFormatarData(historico.dataDesligamento)]'
                        )
                        el-divider(v-if='dados.historicoFuncional.length > 1')
                el-alert(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.informacoesProfissionais.historicoFuncional") && !dados.historicoFuncional',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )

                div(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.informacoesProfissionais.empresasComParticipacaoSocietaria") && dados.participacaoSocietariaUnico'
                )
                    el-table.table-infos-imoveis-pf(
                        :data='dados.participacaoSocietariaUnico',
                        height='100%',
                        :default-sort='{ prop: "razaoSocial", order: "ascending" }',
                        style='width: 100%; max-height: 300px; overflow: auto',
                        stripe
                    )
                        el-table-column(
                            :label='$t("mensagens.preAnaliseCredito.informacoesProfissionais.razaoSocial")',
                            prop='razaoSocial',
                            align='left',
                            sortable,
                            min-width='250px'
                        )
                        el-table-column(
                            label='CNPJ',
                            :formatter='formatCpfCnpjTableColumn',
                            prop='cnpj',
                            align='left',
                            min-width='170px'
                        )
                        el-table-column(
                            :label='$t("mensagens.preAnaliseCredito.informacoesProfissionais.situacao")',
                            prop='situacao',
                            align='left',
                            min-width='160px'
                        )
                        el-table-column(
                            :label='$t("mensagens.preAnaliseCredito.informacoesProfissionais.acoes")',
                            align='center',
                            min-width='90'
                        )
                            .template.d-flex.justify-content-center(
                                slot-scope='scope'
                            )
                                el-dropdown.action-button(trigger='click')
                                    span.el-dropdown-link
                                        i.mdi.mdi-dots-vertical
                                    el-dropdown-menu(slot='dropdown')
                                        el-dropdown-item(
                                            icon='el-icon-view',
                                            @click.native='abrirModalDetalhesInfosProfissionais(scope.row)'
                                        ) {{ $t('mensagens.preAnaliseCredito.informacoesProfissionais.verInformacoesDetalhadas') }}
                el-alert(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.informacoesProfissionais.empresasComParticipacaoSocietaria") && !dados.participacaoSocietariaUnico',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )
                .tabela-rodape-somatorio(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.informacoesProfissionais.empresasComParticipacaoSocietaria") && dados.participacaoSocietariaUnico'
                )
                    p {{ dados.participacaoSocietariaUnico.length }} {{ $t('mensagens.preAnaliseCredito.informacoesProfissionais.empresasSocietarias') }}

                div(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.informacoesProfissionais.produtorRural") && dados.sintegraRural'
                )
                    div(v-for='sintegra in dados.sintegraRural.ies')
                        BaseInfoBlock(
                            :titulos-info-block='[$t("mensagens.preAnaliseCredito.informacoesProfissionais.inicioAtividadeProdutorRural"), $t("mensagens.comuns.municipioUf")]',
                            :valores-info-block='[mxFormatarData(sintegra.dataInicioAtividade), tratarEndereco(sintegra.endereco)]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block='[$t("mensagens.preAnaliseCredito.informacoesProfissionais.inscricaoEstadual"), $t("mensagens.preAnaliseCredito.informacoesProfissionais.situacaoRegistroProdutorRural")]',
                            :valores-info-block='[sintegra.ie, sintegra.situacao]'
                        )
                        el-divider.mb-2(
                            v-if='dados.sintegraRural.ies.length > 1'
                        )
                el-alert(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.informacoesProfissionais.produtorRural") && !dados.sintegraRural',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )

                div(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.informacoesProfissionais.portalDaTransparencia") && dados.transparencia'
                )
                    div(v-for='(transparencia, index) in dados.transparencia')
                        BaseInfoBlock(
                            :titulos-info-block='[$t("mensagens.preAnaliseCredito.informacoesProfissionais.instituicaoQueExerceFuncao"), $t("mensagens.preAnaliseCredito.informacoesProfissionais.cargo")]',
                            :valores-info-block='[transparencia.unidadeOrganizacional, transparencia.cargo]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block='[$t("mensagens.preAnaliseCredito.informacoesProfissionais.unidadeOrganizacionalQuePrestaServico"), $t("mensagens.preAnaliseCredito.informacoesProfissionais.orgaoDeInstanciaSuperiorAoOrgaoQuePrestaServico")]',
                            :valores-info-block='[transparencia.instituicao, transparencia.orgaoSuperior]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block='[$t("mensagens.preAnaliseCredito.informacoesProfissionais.remuneracaoBruta"), $t("mensagens.preAnaliseCredito.informacoesProfissionais.remuneracaoLiquida")]',
                            :valores-info-block='[formatValorBRL(transparencia.remBruta), formatValorBRL(transparencia.remLiquida)]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block='[$t("mensagens.preAnaliseCredito.informacoesProfissionais.vinculoInstituicaoQueExerceFuncao"), $t("mensagens.preAnaliseCredito.informacoesProfissionais.fonte")]',
                            :valores-info-block='[transparencia.vinculo, transparencia.fonte]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block='[$t("mensagens.preAnaliseCredito.informacoesProfissionais.ultimaAtualizacao")]',
                            :valores-info-block='[transparencia.mesAnoPagamento]'
                        )
                        el-divider(
                            v-if='index !== dados.transparencia.length - 1',
                            style='margin-bottom: 3.5rem'
                        )
                el-alert(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.informacoesProfissionais.portalDaTransparencia") && !dados.transparencia',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )
    BaseModalVisualizarInfos(
        v-if='modalDetalhesInfosProfissionais',
        :show='modalDetalhesInfosProfissionais',
        width='800px',
        @closeDialog='modalDetalhesInfosProfissionais = false; dadosModalDetalhesInfosProfissionais = ""'
    )
        slot
            BaseInfoBlock(
                :titulos-info-block='[$t("mensagens.preAnaliseCredito.informacoesProfissionais.municipio"), $t("mensagens.preAnaliseCredito.informacoesProfissionais.uf")]',
                :valores-info-block='[dadosModalDetalhesInfosProfissionais.municipio, dadosModalDetalhesInfosProfissionais.uf]'
            )
            el-divider
            BaseInfoBlock(
                :titulos-info-block='[$t("mensagens.preAnaliseCredito.informacoesProfissionais.dataAberturaEmpresa"), $t("mensagens.preAnaliseCredito.informacoesProfissionais.dataEntradaSocioEmpresa")]',
                :valores-info-block='[mxFormatarData(dadosModalDetalhesInfosProfissionais.dataAbertura), mxFormatarData(dadosModalDetalhesInfosProfissionais.dataPrimeiraCaptura)]'
            )
            el-divider
            BaseInfoBlock(
                :titulos-info-block='[$t("mensagens.preAnaliseCredito.informacoesProfissionais.ramoAtividadeEmpresa"), $t("mensagens.preAnaliseCredito.informacoesProfissionais.qualificacaoSocioEmpresa")]',
                :valores-info-block='[dadosModalDetalhesInfosProfissionais.ramoAtividade, dadosModalDetalhesInfosProfissionais.capitalSocialEmpresa]'
            )
            el-divider
            BaseInfoBlock(
                :titulos-info-block='["CNAE", $t("mensagens.preAnaliseCredito.informacoesProfissionais.capitalSocialEmpresa")]',
                :valores-info-block='[dadosModalDetalhesInfosProfissionais.descricaoCnae, dadosModalDetalhesInfosProfissionais.uf]'
            )
            el-divider
            BaseInfoBlock(
                :titulos-info-block='[$t("mensagens.preAnaliseCredito.informacoesProfissionais.faturamentoAnualEstimado"), $t("mensagens.preAnaliseCredito.informacoesProfissionais.faturamentoEstimadoGrupo")]',
                :valores-info-block='[dadosModalDetalhesInfosProfissionais.faixaFaturamentoPresumido, dadosModalDetalhesInfosProfissionais.faixaFaturamentoPresumidoGrupo]'
            )
            el-divider
            BaseInfoBlock(
                :titulos-info-block='[$t("mensagens.preAnaliseCredito.informacoesProfissionais.participacaoCapitalSocial"), $t("mensagens.preAnaliseCredito.informacoesProfissionais.qualificacao")]',
                :valores-info-block='[dadosModalDetalhesInfosProfissionais.participacaoCapitalSocial, dadosModalDetalhesInfosProfissionais.qualificacao]'
            )
            el-divider
            BaseInfoBlock(
                :titulos-info-block='[$t("mensagens.preAnaliseCredito.informacoesProfissionais.participacaoPorcentagem")]',
                :valores-info-block='[dadosModalDetalhesInfosProfissionais.valorParticipacao]'
            )
</template>

<script>
import formatters from '@/utils/formatters';

import preAnaliseServiceMixin from '@/modules/pre-analise-credito/mixins/PreAnaliseCreditoMixin';

import BaseTableHeader from '@/modules/pre-analise-credito/components/BaseTableHeader';
import BaseInfoBlock from '@/modules/pre-analise-credito/components/BaseInfoBlock';
import BaseModalVisualizarInfos from '@/modules/pre-analise-credito/components/BaseModalVisualizarInfos';

export default {
    name: 'TabelaPatrimonioPf',

    components: {
        BaseTableHeader,
        BaseInfoBlock,
        BaseModalVisualizarInfos
    },

    mixins: [preAnaliseServiceMixin],

    props: {
        tituloTabela: {
            type: String,
            required: true,
            default: 'Tabela'
        },
        iconeTituloTabela: {
            type: String,
            required: true,
            default: 'mdi mdi-cloud-search-outline'
        },
        dados: {
            type: Object,
            required: true,
            default: () => {}
        }
    },

    data() {
        return {
            activeCollapseItem: ['0'],
            modalDetalhesInfosProfissionais: false,
            dadosModalDetalhesInfosProfissionais: ''
        };
    },
    computed: {
        tiposInfosProfissionais() {
            return (
                this.mxCheckTiposInfosProfissionaisPFResults(this.dados) || []
            );
        }
    },

    methods: {
        abrirModalDetalhesInfosProfissionais(row) {
            this.modalDetalhesInfosProfissionais = true;
            this.dadosModalDetalhesInfosProfissionais = row;
        },
        formatarCep(row, column, cep, index) {
            return formatters.formatarCEP(cep);
        },
        isEmpty(row, column, data, index) {
            return formatters.isEmpty(data);
        },
        numeralStringFormatTocpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },
        formatCpfCnpjTableColumn(row, column, cpfCnpj, index) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },
        tratarEndereco(endereco) {
            return endereco.municipio + '-' + endereco.uf;
        },
        formatValorBRL(valor) {
            return 'R$ ' + formatters.formatNumber(valor, 2);
        }
    }
};
</script>

<style lang="scss">
#tabela-infos-profissionais-pf {
    font-family: 'Roboto', 'sans serif' !important;
    border-radius: 5px 5px 0 0 !important;

    h1 {
        border-bottom: 1px solid #359138;
        margin-bottom: 18px;
        width: 100%;
        line-height: 42px;
    }

    i.mdi {
        color: var(--primary);
        margin-right: 10px;
        font-size: 24px;
    }

    .tabela-titulo {
        color: var(--primary);
        font-size: 18px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
    }

    .table-infos-imoveis-pf {
        height: 100%;
        width: 100%;

        .action-button {
            cursor: pointer;
        }
    }

    .el-collapse-item {
        border: 1px solid #d9d9d9 !important;
        border-radius: 5px;
        margin-bottom: 12px;
    }

    .el-collapse-item__header {
        position: relative;
        border-radius: 5px;
        height: 35px !important;
        padding: 22px 0px 22px 40px;
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
    }

    .el-collapse-item__arrow {
        position: absolute;
        left: 10px;
        top: 31%;
        font-size: 16px;
        font-weight: 600;
    }

    .el-collapse-item__wrap {
        padding: 12px;
        border-bottom: none !important;
    }

    .el-collapse-item__content {
        padding-bottom: 5px !important;
    }

    .tabela-rodape-somatorio p {
        margin-bottom: 0;
        color: var(--primary);
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        margin-left: 21px;
        padding-top: 17px;
    }
}
</style>
